module.exports = __webpack_public_path__ + "static/media/sms_enrollment_numbers_assigning.eb80edca.png";